export const isFeatureEnabled = () => {
    return process.env.FEATURE_ENABLED === 'true'
}
